import { Box, Checkbox, FormControlLabel, Grid, LinearProgress, TextField, Typography } from '@mui/material';
import grey from '@mui/material/colors/grey';
import { makeStyles } from '@mui/styles';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '../components/TimePicker';
import AccessTagsDropdown from '../components/AccessTagsDropdown';
import FormActionButtons from '../components/FormActionButtons';
import FormLicenseeContext from '../components/FormLicenseeContext';
import LicenseeFormField from '../components/LicenseeFormField';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import * as React from 'react';
import { Prompt, useHistory } from 'react-router';

import { CREATE, DataAPIContext } from '../api';
import PageMeta from '../components/PageMeta';
import RemoteAutocomplete from '../components/RemoteAutocomplete';
import { ContextStore } from '../store/contextStore';
import { disableMuiButton, enableMuiButton } from '../utils';
import AssociatedUserField from './AssociatedUserField';
import SchemaSections from './SchemaSections';

const useStyles = makeStyles((theme) => ({
    root: {
        border: `1px solid ${grey[200]}`,
        borderRadius: '5px',
        width: '90%',
        [theme.breakpoints.down('sm')]: {
            width: '99.5%',
        },
    },
    gridRoot: {
        padding: '1rem',
    },
    buttonPanel: {
        marginTop: theme.spacing(4),
        backgroundColor: grey[100],
    },
}));

const validateInput = (tag, isFranchise) => {
    const errors = {};
    let canSave = true;
    if (isFranchise && !tag.tour_operator) {
        errors.tour_operator = { error: true, helperText: 'Licensee is required' };
        canSave = false;
    }
    if (!tag.category) {
        errors.name = { error: true, helperText: 'Category is required' };
        canSave = false;
    }
    if (!tag.name) {
        errors.name = { error: true, helperText: 'Tag name is required' };
        canSave = false;
    }
    return { canSave, errors };
};

const TagCreate = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const { isFranchise, currentLicensee } = React.useContext(ContextStore);
    const resource = 'tour_tag';
    const history = useHistory();
    const classes = useStyles();
    const saveRef = React.useRef(null);
    const [syncActive, setSyncActive] = React.useState(false);

    // eslint-disable-next-line no-unused-vars
    const [serverErrors, setServerErrors] = React.useState([]);
    const { enqueueSnackbar } = useSnackbar();
    // const [tourOperatorTagCategories, setTourOperatorTagCategories] = React.useState();
    const [selectedTagCategory, setSelectedTagCategory] = React.useState();
    const [tag, setTag] = React.useState({
        category: null,
        category_display: '',
        data: {},
        name: '',
        tour_operator: currentLicensee || null,
        _changed: false,
    });

    const [requiredTagFieldsError, setRequiredTagFieldsError] = React.useState(false);
    const [missingRequired, setMissingRequired] = React.useState([]);
    const [existingTagError, setExistingTagError] = React.useState(false);
    const [leavePromptAcknowledged, setLeavePromptAcknowledged] = React.useState(false);

    const onCategoryChange = (ev, nv) => {
        setTag((prevState) => ({
            ...prevState,
            category_display: nv,
            category: nv?.id,
            // The External ID field only exists for an externally identified
            // category and the API refuses one anywhere else, so a value left
            // over from a previous pick must not ride along invisibly.
            ...(nv?.external_identity ? {} : { custom_id: '' }),
        }));
        setSelectedTagCategory(nv);
    };

    const onAssociatedUserChange = (ev, nv) => {
        setTag((prevState) => ({ ...prevState, user: nv }));
    };

    const onAccessTagsChange = (ev, atags, reason) => {
        setTag((prevState) => ({ ...prevState, atag: atags, _changed: true }));
        props.setDetailsDirty && props.setDetailsDirty(true);
    };

    const handleChange = (ev) => {
        if (ev.target.name === "name") {
            setExistingTagError(false);
        }
        setTag((prevState) => ({ ...prevState, [ev.target.name]: ev.target.value, _changed: true }));
    };
    const handleDataChange = (ev) => {
        console.log('tagCreateTesting', ev);
        setTag((prevState) => ({ ...prevState, data: { ...tag.data, [ev.target.name]: ev.target.value }, _changed: true }));
    };

    // React.useEffect(() => {
    //     const fetchTagCategories = () => {

    //         const params = {
    //             urlSuffix: null
    //         }
    //         dataAPI(GET_LIST, "tour_tag_category", params)
    //             .then(res => {
    //                 console.log('check tour_tag_category ', res);

    //                 if (res.data && res.data.length > 0) {
    //                     console.log('check tour_tag_category with data ', res);
    //                     setTourOperatorTagCategories(res.data)
    //                 } else {

    //                     console.log('check tour_tag_category none ');

    //                 }
    //             })
    //     }
    //     fetchTagCategories()
    // }, []);

    // const createTagCategory = async () => {
    //     setSyncActive(true);

    //     let tagCategoryExample =
    //     {
    //         "code": "category-hotel-example",
    //         "created_ts": "2022-04-17T13:43:49.599573Z",
    //         "id": 2,
    //         "max_tags": 2,
    //         "merge_order": 3,
    //         "name": "Hotel Example",
    //         "schema": {
    //             "longitude": null,
    //             "latitude": null,
    //             "name": null,
    //             "pickup_time": null,
    //         },
    //         "tour_operator": 21,
    //         "updated_ts": "2022-04-17T13:43:49.599592Z",
    //         "user_selected": false
    //     }

    //     const res = await dataAPI(CREATE, "tour_tag_category", { data: tagCategoryExample });
    //     console.log('create', res);
    //     if (res.statusCode === 201) {
    //         enqueueSnackbar("Tour Category Createad", { variant: 'success' });
    //         setSyncActive(false);
    //     } else if (res.statusCode === 406) {
    //         enqueueSnackbar("Tag validation error", { variant: 'warning' });
    //         console.log('validation errors', res.data);
    //         setServerErrors(res.data.errors);
    //         setSyncActive(false);

    //     }
    // }

    const handleSave = (ev) => {
        if (!checkIfRequiredAreMissing(tag, selectedTagCategory)) {
            setSyncActive(true);
            disableMuiButton(saveRef.current);
            (async () => {
                try {
                    const res = await dataAPI(CREATE, resource, { data: tag });
                    if (res.statusCode === 201) {
                        enqueueSnackbar('Tag created', { variant: 'success' });
                        setTag({ ...tag, _changed: false });
                        history.push(`/tags`);
                    } else if (res.statusCode === 400) {
                        // A plain 400 is an unexpected server error (or a permission
                        // denial carrying its own message), not a duplicate name.
                        enqueueSnackbar(res.data?.message || 'Error creating tag, please try again', { variant: 'error' });
                        setServerErrors(res.data?.errors);
                    } else if (res.statusCode === 406) {
                        const message = res.data?.message || 'Tag name must be unique';
                        // Only flag the name field for the duplicate-name error; other
                        // 406s (unknown category / associated user) carry their own message.
                        setExistingTagError(/duplicate|unique/i.test(message));
                        enqueueSnackbar(message, { variant: 'error' });
                        setServerErrors(res.data?.errors);
                    }
                } finally {
                    setSyncActive(false);
                    if (saveRef && saveRef.current) {
                        enableMuiButton(saveRef.current);
                    }
                }
            })();
        }
    };

    const onLicenseeChange = (id) => {
        setTag((prev) => ({ ...prev, tour_operator: id, _changed: true }));
    };
    const { canSave, errors } = validateInput(tag, isFranchise);

    const checkIfRequiredAreMissing = (tag, selectedTagCategory) => {
        setRequiredTagFieldsError(false);
        let error = false;
        let required_fields = selectedTagCategory?.schema?.required;
        let existing_fields = tag?.data;
        const missing = [];
        if (required_fields) {
            for (let i = 0; i < required_fields.length; i++) {
                if (!(required_fields[i] in existing_fields)) {
                    error = true;
                    missing.push(required_fields[i]);
                    setRequiredTagFieldsError(true);
                }
            }
            for (let i = 0; i < required_fields.length; i++) {
                if (required_fields[i] in existing_fields) {
                    if (!existing_fields[required_fields[i]] || existing_fields[required_fields[i]] === '') {
                        error = true;
                        missing.push(required_fields[i]);
                        setRequiredTagFieldsError(true);
                    }
                }
            }
        }
        // A collapsed section opens again when it holds one of these (CP-7988).
        setMissingRequired(missing);
        return error;
    };

    const onCheckBoxChange = (ev) => {
        setTag((prev) => ({ ...prev, data: { ...prev.data, [ev.target.name]: ev.target.checked } }));
    };

    const onTImeChange = (time, key) => {
        setTag((prev) => ({ ...prev, data: { ...prev.data, [key]: time.format('HH:mm') } }));
    };

    return (
        <div className={classes.root}>
            <PageMeta title="Create New Tag" />
            <Prompt
                when={!!tag._changed && leavePromptAcknowledged === false}
                message={() => {
                    setLeavePromptAcknowledged(true);
                    return 'Are you sure you want to leave without saving changes?';
                }
                }
            />
            <FormLicenseeContext.Provider value={tag.tour_operator}>
            <div className={classes.gridRoot}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                        <LinearProgress color="primary" style={{ visibility: syncActive ? 'visible' : 'hidden' }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6">Create New Tag</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <LicenseeFormField value={tag.tour_operator} onChange={onLicenseeChange} error={errors.tour_operator?.error} helperText={errors.tour_operator?.helperText} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField required variant="filled" size="small" fullWidth label="Tag Name" name="name" onChange={handleChange} value={tag.name} error={existingTagError} helperText={existingTagError && "Tag already exists"} />
                    </Grid>
                    <Grid item xs={12}>
                        <AccessTagsDropdown value={tag.atag} onChange={onAccessTagsChange} />
                    </Grid>
                    <Grid item xs={12}>
                        <RemoteAutocomplete required resource="tour_tag_category" urlSuffix={null} label="Choose Tag Category" variant="filled" size="small" onChange={onCategoryChange} value={tag.category_display || null} />
                    </Grid>

                    {selectedTagCategory?.external_identity && (
                        <Grid item xs={12}>
                            <TextField
                                variant="filled"
                                size="small"
                                fullWidth
                                label="External ID"
                                name="custom_id"
                                placeholder="Set external ID"
                                onChange={handleChange}
                                value={tag.custom_id || ''}
                                inputProps={{ maxLength: 128 }}
                                helperText="This category identifies tags by their upstream id, so two tags may share a name. Leave empty to identify this one by name instead."
                            />
                        </Grid>
                    )}

                    <SchemaSections
                        schema={selectedTagCategory?.schema}
                        stateKey={selectedTagCategory?.id}
                        attentionKeys={missingRequired}
                        renderField={(key) => {
                            const field = selectedTagCategory?.schema.properties[key];
                            const type = selectedTagCategory?.schema.properties[key]?.type;
                            const format = selectedTagCategory?.schema.properties[key]?.format;

                            if (type === 'boolean') {
                                return (
                                    <Grid item xs={12} key={key}>
                                        <FormControlLabel
                                            control={<Checkbox checked={tag.data[key]} required={selectedTagCategory?.schema?.required?.constructor === Array && selectedTagCategory?.schema.required.indexOf(key) >= 0} onChange={onCheckBoxChange} name={key} color="primary" />}
                                            label={selectedTagCategory?.schema?.required?.constructor === Array && selectedTagCategory?.schema.required.indexOf(key) >= 0 ? selectedTagCategory?.schema.properties[key]?.name + ' *' : selectedTagCategory?.schema.properties[key]?.name}
                                        />
                                    </Grid>
                                );
                            }
                            if (format === 'date-time') {
                                return (
                                    <Grid item xs={12} key={key}>
                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <TimePicker
                                                label={selectedTagCategory?.schema?.properties[key]?.name}
                                                value={tag.data[key] ? moment(tag.data[key], 'HH:mm') : moment()}
                                                onChange={(newValue) => {
                                                    onTImeChange(newValue, key);
                                                }}
                                                required={selectedTagCategory?.schema?.required?.constructor === Array && selectedTagCategory?.schema.required.indexOf(key) >= 0}
                                                renderInput={(params) => <TextField fullWidth variant="filled" required={selectedTagCategory?.schema?.required?.constructor === Array && selectedTagCategory?.schema.required.indexOf(key) >= 0} {...params} />}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                );
                            }
                            return (
                                <Grid item xs={12} key={key}>
                                    <TextField
                                        variant="filled"
                                        size="small"
                                        fullWidth
                                        required={selectedTagCategory?.schema?.required?.constructor === Array && selectedTagCategory?.schema.required.indexOf(key) >= 0}
                                        name={key}
                                        label={field.title || key}
                                        value={field.default}
                                        onChange={handleDataChange}
                                        helperText={field.description}
                                    />
                                </Grid>
                            );
                        }}
                    />

                    <Grid item xs={12}>
                        <AssociatedUserField onChange={onAssociatedUserChange} value={tag.user} />
                    </Grid>
                </Grid>
                {requiredTagFieldsError && (
                    <Box sx={{ mt: 2 }}>
                        <Typography color="secondary">Please fill in all required fields before saving</Typography>
                    </Box>
                )}
                <Box className={classes.buttonPanel} sx={{ py: 1, px: 0 }}>
                    <FormActionButtons
                        submitRef={saveRef}
                        onSubmit={handleSave}
                        submitDisabled={!canSave}
                        onCancel={() => history.push('/tags')}
                    />
                </Box>
            </div>
            </FormLicenseeContext.Provider>
        </div>
    );
};

export default TagCreate;
